import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { PedidoPdf } from '../models/pedido-pdf';
import { PedidoService } from '../pedido.service';


@Injectable({ providedIn: 'root'})
export class PedidoPdfResolver implements Resolve<Observable<PedidoPdf>>{

    constructor(private pedidoService: PedidoService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const idPedido = route.params.id;
        return this.pedidoService.getPedidoPdf(idPedido);
    }

}